exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-form-container[data-v-3d395f82] {\n  margin-bottom: 16px;\n}\n.search-form-container[data-v-3d395f82]  .el-form-item {\n  margin-bottom: 16px;\n}", ""]);

// exports
